export default __webpack_public_path__ + "static/media/millsberry-white-logo.72e21853.png";